import React, { Component } from "react";
import { connect } from "react-redux";
import moment from "moment";
import { newSeasonFilterStyle, periodFilterStyle, yearsFilterStyle } from "../../../services/utils";
import ReactSelect, { components } from "react-select";
import { setEventStatsYear } from "../../../actions/actions/eventStats";


const DropdownIndicator = props => {
  return (
    <components.DropdownIndicator {...props}>
      <img src={"/img/icons/Polygon.svg"} className={'mr-1'} />
    </components.DropdownIndicator>
  );
};

class PeriodFilterPaper extends Component {

  // handleSelectChange = (value) => {
  //   let selectedYears = value.map(year => '' + year.value);
  //   this.props.setEventStatsYear(selectedYears);
  // }

  handleSelectChange = (value) => {
    let selectedYear = value.value;
    this.props.onChangePeriod(selectedYear);
  };

  render() {
    const currentYear = moment().year();
    const yearsOptions = this.props.yearsOptions 
    ? this.props.yearsOptions 
    : Array.from(
      { length: currentYear - 2025 + 1 },
      (_, i) => {
        const year = currentYear - i;
        return { value: year, label: year };
      }
    );

    const defaultYearOption = yearsOptions.find(
      (opt) => opt.value === currentYear
    );

    return (
      /*<ReactSelect
        className="my-2 mx-4 event-small-filter"
        onChange={this.handleSelectChange}
        styles={periodFilterStyle()}
        defaultValue={{value: (moment().format('YYYY')), label: (moment().format('YYYY'))}}
        options={yearsOptions}
        components={{ DropdownIndicator, IndicatorSeparator:() => null, Input:() => null}}
      />*/
      // <ReactSelect
      //   onChange={this.handleSelectChange}
      //   isClearable={false}
      //   isMulti
      //   styles={yearsFilterStyle()}
      //   defaultValue={defaultYearOption ? [defaultYearOption] : []}
      //   options={yearsOptions}
      //   components={{ DropdownIndicator, IndicatorSeparator: () => null, Input: () => null, Placeholder: () => null }}
      // />
      <ReactSelect
        onChange={this.handleSelectChange}
        styles={newSeasonFilterStyle()}
        defaultValue={defaultYearOption ? defaultYearOption : null}
        options={yearsOptions}
        components={{ DropdownIndicator, IndicatorSeparator: () => null, Input: () => null }}
      />
    );
  }
}

const mapStateToProps = state => ({});

const mapDispatchToProps = {
  setEventStatsYear,
};

export default connect(mapStateToProps, mapDispatchToProps)(PeriodFilterPaper);



// WEBPACK FOOTER //
// ./app/components/Filters/EventStats/PeriodFilterPaper.js